import axios from 'axios'
import { SAVINGS_PLAN_ENDPOINT } from 'common/backend/endpoints'

export async function getPaginatedListSavingsPlan({ search, cancelToken }) {
    let searchSavingsPlan = search.replace("&product_type=plan-ahorro", "")
    
    const endpoint = `${SAVINGS_PLAN_ENDPOINT}/${searchSavingsPlan}`

    const { data }  = await axios.get(endpoint, { cancelToken })

    return data
}